import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ($props.data.is && $props.data.slot)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent($props.data.is), _mergeProps({
            key: 0,
            onClick: $props.data.click
        }, { ...$props.data }), {
            default: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.data.slot), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 16 /* FULL_PROPS */, ["onClick"]))
        : ($props.data.is)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent($props.data.is), _normalizeProps(_mergeProps({ key: 1 }, { ...$props.data })), null, 16 /* FULL_PROPS */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(_toDisplayString($props.data), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */));
}
